import {
  queryKeyChains,
  queryKeyPages,
  queryKeyPropertyTypes,
  queryKeySubChains,
} from 'constants/url'
import { EmptyArray } from 'lib/array/arrayUtils'
import {
  HOME_PROPERTY_TYPES,
  HOTEL_PROPERTY_TYPE,
  SEARCH_VERTICAL_TAB_OPTIONS,
  type SearchVertical,
} from './SearchVerticalTabs.config'

export function isHotelPropertyType(propertyType: string): boolean {
  return propertyType === HOTEL_PROPERTY_TYPE
}

export function isHomePropertyType(propertyType: string): boolean {
  return HOME_PROPERTY_TYPES.includes(propertyType)
}

export function getSearchVerticalTabOptions(
  selectedPropertyTypes: Array<string> = EmptyArray,
  availablePropertyTypes: Array<App.FilterItem> = EmptyArray,
): Array<SearchVertical> {
  const activeTab = getActiveSearchVerticalTab(selectedPropertyTypes)

  if (activeTab !== 'all') {
    return SEARCH_VERTICAL_TAB_OPTIONS
  }

  const hasHotels = availablePropertyTypes.some(({ slug }) => isHotelPropertyType(slug))
  const hasHomes = availablePropertyTypes.some(({ slug }) => isHomePropertyType(slug))

  if (!hasHotels || !hasHomes) {
    return EmptyArray
  }

  return SEARCH_VERTICAL_TAB_OPTIONS
}

export function getSearchVerticalAvailabilityFilters(filters: App.OfferListFilters): App.OfferListFilters {
  const { chains: _chains, subChains: _subChains, isStream: _isStream, ...filtersWithoutChains } = filters

  return filtersWithoutChains
}

export function getActiveSearchVerticalTab(selectedPropertyTypes: Array<string> = EmptyArray): SearchVertical {
  if (selectedPropertyTypes.length === 1 && isHotelPropertyType(selectedPropertyTypes[0])) {
    return 'hotels'
  }

  if (selectedPropertyTypes.length > 0 && selectedPropertyTypes.every(isHomePropertyType)) {
    return 'homes'
  }

  return 'all'
}

export function getHomePropertyTypeValues(availablePropertyTypes: Array<App.FilterItem> = EmptyArray): Array<string> {
  const availableHomePropertyTypes = availablePropertyTypes
    .map(({ slug }) => slug)
    .filter(isHomePropertyType)

  if (availableHomePropertyTypes.length > 0) {
    return availableHomePropertyTypes
  }

  return HOME_PROPERTY_TYPES
}

export function getPropertyTypesForSearchVertical(
  searchVertical: SearchVertical,
  availablePropertyTypes: Array<App.FilterItem> = EmptyArray,
): string | undefined {
  if (searchVertical === 'hotels') return HOTEL_PROPERTY_TYPE
  if (searchVertical === 'homes') return getHomePropertyTypeValues(availablePropertyTypes).join(',')
  return undefined
}

export function getSearchParamValuesForSearchVertical(
  searchVertical: SearchVertical,
  availablePropertyTypes: Array<App.FilterItem> = EmptyArray,
): Array<{ paramName: string, paramValue: string | undefined }> {
  const searchParamValues = [
    { paramName: queryKeyPropertyTypes, paramValue: getPropertyTypesForSearchVertical(searchVertical, availablePropertyTypes) },
    { paramName: queryKeyPages, paramValue: undefined },
    { paramName: 'limit', paramValue: undefined },
  ]

  if (searchVertical === 'homes') {
    searchParamValues.push({ paramName: queryKeyChains, paramValue: undefined })
    searchParamValues.push({ paramName: queryKeySubChains, paramValue: undefined })
  }

  return searchParamValues
}

export function isHotelsSearchVertical(selectedPropertyTypes: Array<string> = EmptyArray): boolean {
  return getActiveSearchVerticalTab(selectedPropertyTypes) === 'hotels'
}

export function isHomesSearchVertical(selectedPropertyTypes: Array<string> = EmptyArray): boolean {
  return getActiveSearchVerticalTab(selectedPropertyTypes) === 'homes'
}
